<template>
  <div id="loader-wrapper">
    <div id="preloader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div id="label">
      <div class="loader-title">{{title}}</div>
      <div class="loader-subtitle">{{subtitle}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { 

    };
  },
  props: {
    title: String,
    subtitle: String,
    center: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/activation.scss";

#loader-wrapper {
  width: 200px;
  height: 80px;
  z-index: 1000;
  position: absolute;
}

#preloader {
  margin-left: 50%;
}

#preloader span {
  display: block;
  position: absolute;
  border-radius: 16px;
  height: 8px;
  left: 0px;
  width: 32px;
  bottom: 0;
  background: $blue-800;
  animation: preloader 2.5s infinite cubic-bezier(0.4, 0.0, 0.2, 1) ;
}

#preloader span:nth-child(2){
  left: 40px;  
  animation-delay: 100ms;
}

#preloader span:nth-child(3){
  left: 80px;
  animation-delay: 200ms;
}

#preloader span:nth-child(4){
  left: 120px;
  animation-delay: 300ms;
}

#preloader span:nth-child(5){
  left: 160px;
  animation-delay: 400ms;
}

@keyframes preloader {
  0% { height: 8px; transform: translateY(0px); background: $blue-200;   }
  25% { height: 60px; transform: translateY(-14px); background: $blue-400; }
  50% {height:4px; transform: translateY(0px); background:$blue-600; }
  100%{ height:4px; transform:translateY(0px) ;background:$blue-800; }
}

#label {
  position: absolute;
  bottom: 15px;  
  text-align: center;
  width: 100%;
}

.loader-subtitle {  
  font-size: 1em;
  text-align: center;
}
.loader-title {  
  font-size: 1.6em;
  text-align: center;
}

</style>
